import { render, staticRenderFns } from "./screen-campaigns.vue?vue&type=template&id=5c801f06"
import script from "./screen-campaigns.vue?vue&type=script&lang=js"
export * from "./screen-campaigns.vue?vue&type=script&lang=js"
import style0 from "./screen-campaigns.vue?vue&type=style&index=0&id=5c801f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports